import './App.css';

import React, { Component } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import Home from './pages/Home'
import uuidV1 from 'uuid/v1'
import ThemeStore from './stores/ThemeStoreActions'
import MessageService from './services/MessageService'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'

class App extends Component {

  componentDidMount () {
    const deviceUuid = uuidV1()
    ThemeStore.setDeviceUuid(deviceUuid)
    MessageService.init(deviceUuid)
  }

  render () {

    const theme = createMuiTheme({
      typography: {
        // Use the system font.
        fontFamily:
          'FSMe, sans-serif'
      }
    })

    return (
      <MuiThemeProvider theme={theme}>
        <Router>
          <div>
            <Route path='/' component={Home} />
          </div>
        </Router>
      </MuiThemeProvider>
    )
  }
  
}

export default App



// WEBPACK FOOTER //
// ./src/App.js